<template>
  <div v-wechat-title="$route.meta.title='所有推送'">
    <div :style="background"></div>
  <van-pull-refresh :disabled="disabled" style="min-height: 100vh"  v-model="isLoading" @refresh="onRefresh">
    <van-list 
      v-model="loading"
      :finished="finished"
      :offset="1"
      
      finished-text="没有更多了"
      @load="onLoad"
    >

        <div class="video-list" v-for="(item,index) in list">
             <div :style="{width:width+'px'}" class="info">
               <label>{{item.title}}</label>
               <p>
                 <img :src="require('../assets/images/date.png')">&nbsp;&nbsp;
                 <span>推送日期:</span>&nbsp;&nbsp;
                 <span >{{item.create_time}}</span>
               </p>
             </div>
             <!--  <div v-show="!item.playStatus"  class="demo-lazyload"  :style="{width:width+'px',height:height+'px'}"  v-lazy:background-image="item.img">
                  <img @click="play(index,'player-container-id'+item.id)" :src="require('../assets/images/play.png')">
              </div> -->
              <div >
                   <video x5-playsinline="true"  webkit-playsinline="true" playsinline="true"  class="demo-lazyload" :id="'player-container-id'+item.id" :style="{width:width+'px',height:height+'px'}"  :poster="item.img"> 
              </video>
              </div>
               
		    </div>
     </van-list>

</van-pull-refresh>
</div>
</template>
<script>
import { userPush ,videoRecord} from '@/api/api.js'
export default {
    components: {
       
    },
    data(){
        return{
          background: {
              backgroundImage:'url(' + require('../assets/images/bg.jpg') + ')',
              backgroundRepeat:"no-repeat",
              backgroundSize:"100% 100%",
              width: "100%",
              height: "100%",
              position:'fixed',
              
              top:0
             },
            width:320,
            height:180,
            list:[],
            page:1,//页码,默认为1
            pageNum:10,//每页数量
            page_count:1,//总页数,初始为1 
            isLoading: false ,//下拉刷新
            loading: false,
            finished: false,
            player:[],
            disabled:true,
            aid:0
        }
    },
    beforeMount() {
        
    },
    mounted() {
         this.aid = this.$route.query.aid;
         window.screenWidth = document.body.clientWidth
         this.width = window.screenWidth-30;//设置视频长宽比
         this.height = this.width*(9/16);
          
    },
    methods: {
        //下拉刷新
           onRefresh() {
              this.page = 1;
              this.list = [];
              this.onLoad();
              setTimeout(() => {
                this.$toast('刷新成功');
                this.isLoading = false;
                this.finished = false;
              }, 500);
            },
            //下拉加载10
             onLoad() {
              // 异步更新数据
              if(this.page>this.page_count){
                    this.finished = true;
                    this.loading = false;
                    return ;
                }
                let parame = {'aid':this.aid,'page':this.page,'pageNum':this.pageNum};
                userPush(parame).then((res)=>{
                    if(res.code==200){
                        if (res.result.list.length > 0) {//没有数据
                            if(this.list.length==0){
                                    this.list = res.result.list;

                            }else{
                                this.list = this.list.concat(res.result.list)
                                
                            }
                             let _this = this;
                            setTimeout(function(){
                                for (let i = 0; i < res.result.list.length; i++) {
                                      _this.play1(res.result.list[i]);
                                   
                                }
                            },1000)
                            this.page_count = res.result.page_count;
                            this.page++;
                             // 加载状态结束
                            this.loading = false;
                           
                        }else{
                             // 数据全部加载完成
                            this.finished = true;
                            this.loading = false;
                        }  
                    } 
                   //Toast('提示内容')
                  //console.log(this.list);  
                }),(err)=>{
                    console.log(err);
                }
                          
              
         },
          play1(info){
          /* this.list[index].playStatus = 1;
           let info = this.list[index]; */

            this.player[info.id] = TCPlayer('player-container-id'+info.id, { // player-container-id 为播放器容器ID，必须与html中一致
                  fileID: info.fileid, // 请传入需要播放的视频fileID 必须
                  appID: info.appid, // 请传入点播账号的appID 必须
                  autoplay: false //是否自动播放
                  //其他参数请在开发文档中查看
              });
            let _this = this;
            this.player[info.id].on('playing', function(e){
            
               _this.Record({vid:info.id})
              let videoList = document.getElementsByTagName("video");
                for(let i=0;i<videoList.length;i++){
                if(('player-container-id'+info.id+'_html5_api')!=videoList[i].id){
                    videoList[i].pause()
                }
              
              }
            });
           
        },
          Record(parames){
               videoRecord(parames).then((res)=>{                 
               
            }),(err)=>{
                console.log(err);
            }
          },
        play(index,id){
          /* this.list[index].playStatus = 1;
           let info = this.list[index]; */

            this.player = TCPlayer(id, { // player-container-id 为播放器容器ID，必须与html中一致
                  fileID: info.fileid, // 请传入需要播放的视频fileID 必须
                  appID: info.appid, // 请传入点播账号的appID 必须
                  autoplay: false //是否自动播放
                  //其他参数请在开发文档中查看
              });
            this.player.on('playing', function(e){
              let videoList = document.getElementsByTagName("video");
              for(let i=0;i<videoList.length;i++){
                if((id+'_html5_api')!=videoList[i].id){
                    videoList[i].pause()
                }
              
            }
            });
           
            this.player.play();
        },

        //返回上一页
        onClickLeft(){
            this.$router.go(-1)
        },

    	//视频详情
    	videoDetail(id){
    	   
    			this.$router.push({name:'videoDetail',query:{id:id}})	
    	
    	}	
       
    }
}
</script>
<style  >
  @import '//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css';
  .info{
    margin:auto;
    text-align: left;
  }
  .info label{
      color: #fff;
  }
  .info p{
    font-size: .9rem;
    color: #fff;
    margin-top: .3rem;
    margin-bottom:.3rem;
  }
  .info img{
    height: .7rem
  }
  .vjs-poster {
    display: inline-block;
    /* vertical-align: middle; */
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    background-color: #000000;
    cursor: pointer;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
}
.video-list{
   
    padding-bottom:.5rem; 
    margin-bottom:.5rem; 
  }
.demo-lazyload {
	    box-sizing: border-box;
	     margin:auto;
	    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      background-size: 100% 100%;
}
.demo-lazyload img{
  height: 3rem;
    margin-top: 18%;
}
.activity{
	height: 100%;
    width: 100%;
    background-color: white;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position:relative;
    margin-bottom: .6rem;
}
.news_r{
	position: absolute;
    bottom: 0;
    width: 100%;
    color: white;
    background-color: #323233;
    opacity: .8;
}


</style>
